import i18n from 'i18n';
import { actions, createMachine } from 'xstate';
const { pure, assign } = actions;

export const accountMachine = (initial = 'initial') =>
  createMachine({
    id: 'account',
    initial,
    states: {
      initial: {
        entry: pure(context =>
          context.drawer === true ? ['setDark', 'setTitle'] : [],
        ),
        on: {
          LOGIN: 'login',
          REGISTER: [
            {
              cond: (context, event) => !!event.registerData,
              target: 'register',
            },
            {
              cond: context => !!context.passwordlessEnabled,
              target: 'passwordless',
              actions: assign({ passwordlessMode: 'signup' }),
            },
            { target: 'register' },
          ],
          GUEST: 'guest',
          PASSWORDLESS: {
            target: 'passwordless',
            actions: assign({ passwordlessMode: 'signin' }),
          },
        },
        meta: {
          title: i18n.t('drawer.login.loginOrRegister'),
        },
      },
      login: {
        entry: pure(context =>
          context.drawer === true ? ['setLight', 'setTitle'] : [],
        ),
        on: {
          BACK: 'initial',
          FORGOT_PASSWORD: 'forgot_password',
          REGISTER: [
            {
              cond: (context, event) => !!event.registerData,
              target: 'register',
            },
            {
              cond: context => !!context.passwordlessEnabled,
              target: 'passwordless',
              actions: assign({ passwordlessMode: 'signup' }),
            },
            { target: 'register' },
          ],
          CODE_VERIFICATION: 'code_verification',
          PASSWORDLESS: {
            target: 'passwordless',
            actions: assign({ passwordlessMode: 'signin' }),
          },
        },
        meta: {
          title: i18n.t('drawer.login.login'),
        },
      },
      forgot_password: {
        entry: pure(context =>
          context.drawer === true ? ['setLight', 'setTitle'] : [],
        ),
        on: {
          BACK: 'login',
          SUCCESS: 'forgot_password_success',
        },
        meta: {
          title: i18n.t('drawer.login.forgotPassword'),
        },
      },
      forgot_password_success: {
        entry: pure(context =>
          context.drawer === true ? ['setLight', 'setTitle'] : [],
        ),
        on: {
          BACK: 'forgot_password',
        },
        meta: {
          title: i18n.t('drawer.login.forgotPasswordSuccess'),
        },
      },
      register: {
        entry: pure(context =>
          context.drawer === true ? ['setLight', 'setTitle'] : ['refresh'],
        ),
        on: {
          BACK: 'initial',
          LOGIN: 'login',
          CODE_VERIFICATION: 'code_verification',
          REGISTER: 'register',
        },
        meta: {
          title: i18n.t('drawer.login.signUp'),
        },
      },
      guest: {
        entry: pure(context =>
          context.drawer === true ? ['setLight', 'setTitle'] : [],
        ),
        on: {
          BACK: 'initial',
        },
      },
      passwordless: {
        entry: pure(context =>
          context.drawer === true ? ['setLight', 'setTitle'] : [],
        ),
        on: {
          BACK: 'initial',
          MAGIC_LINK_CONFIRMATION: 'magic_link_confirmation',
          OTP_CONFIRMATION: 'otp_confirmation',
          REGISTER: [
            {
              cond: context => context.passwordlessMode === 'signup',
              target: 'register',
            },
            {
              target: 'passwordless',
              actions: assign({ passwordlessMode: 'signup' }),
            },
          ],
          LOGIN: 'login',
        },
        meta: {
          title: i18n.t('passwordless.title'),
        },
      },
      magic_link_confirmation: {
        entry: pure(context =>
          context.drawer === true ? ['setLight', 'setTitle'] : [],
        ),
        on: {
          BACK: 'passwordless',
          LOGIN: 'login',
          REGISTER: 'register',
        },
        meta: {
          title: i18n.t('passwordless.title'),
        },
      },
      otp_confirmation: {
        entry: pure(context =>
          context.drawer === true ? ['setLight', 'setTitle'] : [],
        ),
        on: {
          BACK: 'passwordless',
          LOGIN: 'login',
          REGISTER: 'register',
        },
        meta: {
          title: i18n.t('passwordless.title'),
        },
      },
      code_verification: {
        entry: pure(context =>
          context.drawer === true ? ['setLight', 'setTitle'] : [],
        ),
        on: {
          LOGIN: 'login',
          REGISTER: 'register',
        },
        meta: {
          title: i18n.t('verifyCode.title'),
        },
      },
    },
  });
